(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Shop-by-Wellness-Goals"] && !Shopify.designMode) return;
  try {
    
// Initialize Swiper for Wellness Goals
document.addEventListener('DOMContentLoaded', function() {
  const swiperEl = document.querySelector('.wellness-goals-swiper');
  
  if (swiperEl && typeof Swiper !== 'undefined') {
    const section = swiperEl.closest('.wellness-goals-section');
    const slidesPerView = parseInt(section?.dataset?.slidesPerView || 3);
    const autoplay = section?.dataset?.autoplay === 'true';
    const autoplaySpeed = parseInt(section?.dataset?.autoplaySpeed || 5) * 1000;
    
    new Swiper(swiperEl, {
      slidesPerView: 1,
      spaceBetween: 20,
      loop: true,
      autoplay: autoplay ? {
        delay: autoplaySpeed,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      } : false,
      navigation: {
        nextEl: '.wellness-goals-next',
        prevEl: '.wellness-goals-prev',
      },
      pagination: {
        el: '.wellness-goals-pagination',
        clickable: true,
      },
      speed: 600,
      watchSlidesProgress: true,
      breakpoints: {
        768: {
          slidesPerView: Math.min(2, slidesPerView),
          spaceBetween: 20,
        },
        1024: {
          slidesPerView: Math.min(3, slidesPerView),
          spaceBetween: 25,
        },
        1280: {
          slidesPerView: slidesPerView,
          spaceBetween: 30,
        }
      }
    });
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-slider"] && !Shopify.designMode) return;
  try {
    
// Initialize Swiper for Ayurvedic Banner
document.addEventListener('DOMContentLoaded', function() {
  const swiperEl = document.querySelector('.ayurvedic-banner-swiper');
  
  if (swiperEl && typeof Swiper !== 'undefined') {
    const section = swiperEl.closest('.ayurvedic-banner-section');
    const autoplay = section?.dataset?.autoplay === 'true';
    const autoplaySpeed = parseInt(section?.dataset?.autoplaySpeed || 5) * 1000;
    const effect = section?.dataset?.effect || 'fade';
    
    new Swiper(swiperEl, {
      effect: effect,
      fadeEffect: {
        crossFade: true
      },
      loop: true,
      autoplay: autoplay ? {
        delay: autoplaySpeed,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      } : false,
      navigation: {
        nextEl: '.ayurvedic-banner-next',
        prevEl: '.ayurvedic-banner-prev',
      },
      pagination: {
        el: '.ayurvedic-banner-pagination',
        clickable: true,
      },
      speed: 600,
      watchSlidesProgress: true,
    });
  }
});

  } catch(e) { console.error(e); }
})();
})();
